<template>
  <div class="playlist-go-login">
    <Modal v-if="open" class="mk-modal" @close="close">
      <slot>
        <div class="need-login">
          <div class="text">
            {{ $t('PLAYLIST.LOG_IN_TO_SAVE') }}
          </div>
          <div class="image">
            <img src="@/assets/images/img-playlist/img-login.svg" alt="Need to login">
          </div>
          <div class="login">
            <RouterLink :to="{ name: 'signin', params: {locale: $i18n.localePath()}, query: {type: 'SIGN_IN', redirectURL: currentURL}}"
                        class="mk-btn mk-btn--default"
            >
              {{ $t('AUTH.LOGIN') }}
            </RouterLink>
          </div>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
export default {
  name: 'PlaylistGoLoginModal',
  components: {
    Modal
  },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    currentURL() {
      return this.$route.path
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/variables.scss';

.playlist-go-login {
  .need-login {
    text-align: center;
    .text {
      margin-bottom: 36px;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.63;
      color: $grey-50;
    }
    .image {
      margin-bottom: 46px;
      img {
        height: 160px;
      }
    }
    .login {
      a {
        width: 270px;
      }
    }

  }
}

@media only screen and (min-width: 1440px) {
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}

@media only screen and (max-width: 767.98px) {
  .playlist-go-login {

  }
}

</style>
